import styled from 'styled-components';
import { Icon } from '../../../../styled-components/components/Icon';
import { Wrapper as ScopeAvatar } from '../../../../styled-components/components/ScopeAvatar/wrapper';
import { size } from '../../../../styled-components/layout/helpers';
import { ButtonReset } from '../../../../styled-components/layout/reset';

export const ScopeSelect = styled(ButtonReset)`
  position: relative;
  display: flex;
  align-items: center;
  gap: ${size(2)};
  text-align: left;
  min-width: 0;
  isolation: isolate;

  &::before {
    --_inset-inline: ${size(-2)};

    content: '';
    position: absolute;
    inset: ${size(-0.5)} var(--_inset-inline);
    border-radius: 100vmax;
    background-color: var(--c-mainnav-hover-bg);
    z-index: -1;
    opacity: 0;
  }

  &:hover {
    &::before {
      opacity: 1;
    }
  }

  ${(props) => props.theme.breakpoint.LtMd} {
    max-width: 100%;

    &::before {
      --_inset-inline: ${size(-1)};
    }
  }

  ${(props) => props.theme.breakpoint.Md} {
    margin-left: ${size(2.5)}; // Magic number to horisontally align with the main navigation
  }

  ${ScopeAvatar} {
    flex-shrink: 0;
  }

  ${Icon} {
    flex-shrink: 0;
    font-size: ${(props) => props.theme.font.size.large};
    margin-left: ${size(-1)};
  }
`;

export const ScopeSelectLabel = styled.span`
  font-size: ${(props) => props.theme.font.size.small};
  line-height: ${(props) => props.theme.font.size.regular};
  font-weight: var(--font-weight-bold);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
